(() => {
  const normalize = (value) => String(value || '')
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const slugify = (value) => normalize(value)
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  const initBodyMode = () => {
    document.body.classList.toggle('hv-page-active', Boolean(document.querySelector('.herbz-vault[data-hv-takeover="true"]')));
  };

  const initMenu = (root) => {
    const toggle = root.querySelector('[data-hv-menu-toggle]');
    const menu = root.querySelector('[data-hv-mobile-nav]');
    if (!toggle || !menu || toggle.dataset.initialized === 'true') return;

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });

    menu.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    });

    toggle.dataset.initialized = 'true';
  };

  const initSearch = (root) => {
    const form = root.querySelector('[data-hv-search]');
    if (!form || form.dataset.initialized === 'true') return;

    const input = form.querySelector('input[type="search"]');
    const status = root.querySelector('[data-hv-search-status]');
    const items = [...root.querySelectorAll('[data-hv-search-item]')];
    if (!input || !items.length) return;

    const update = () => {
      const query = normalize(input.value);
      let visible = 0;
      items.forEach((item) => {
        const matches = !query || normalize(item.dataset.hvSearchText).includes(query);
        item.hidden = !matches;
        if (matches) visible += 1;
      });
      if (status) status.textContent = query ? `${visible} resultat${visible === 1 ? '' : 'er'}` : '';
    };

    form.addEventListener('submit', (event) => event.preventDefault());
    input.addEventListener('input', update);
    form.dataset.initialized = 'true';
  };

  const initToc = (root) => {
    const content = root.querySelector('[data-hv-article-content]');
    const list = root.querySelector('[data-hv-toc-list]');
    const chapterNav = root.querySelector('[data-hv-chapter-nav]');
    if (!content || !list || list.dataset.initialized === 'true') return;

    const headings = [...content.querySelectorAll('h2, h3')];
    if (!headings.length) {
      const toc = list.closest('[data-hv-toc]');
      if (toc) toc.hidden = true;
      if (chapterNav) chapterNav.hidden = true;
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `${slugify(heading.textContent) || 'afsnit'}-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      if (heading.tagName === 'H3') link.style.paddingInlineStart = '17px';
      item.append(link);
      list.append(item);

      if (chapterNav && heading.tagName === 'H2' && chapterNav.children.length < 6) {
        const chapterLink = link.cloneNode(true);
        chapterNav.append(chapterLink);
      }
    });

    const links = [...list.querySelectorAll('a')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const active = entries.find((entry) => entry.isIntersecting);
        if (!active) return;
        links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${active.target.id}`));
      }, { rootMargin: '-12% 0px -78% 0px' });
      headings.forEach((heading) => observer.observe(heading));
    }

    list.dataset.initialized = 'true';
  };

  const initProgress = (root) => {
    const bar = root.querySelector('[data-hv-progress]');
    if (!bar || bar.dataset.initialized === 'true') return;
    const update = () => {
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = height > 0 ? Math.min(100, Math.max(0, (window.scrollY / height) * 100)) : 0;
      bar.style.width = `${progress}%`;
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
    bar.dataset.initialized = 'true';
  };

  const initRoot = (root) => {
    initMenu(root);
    initSearch(root);
    initToc(root);
    initProgress(root);
  };

  const initAll = (scope = document) => {
    initBodyMode();
    scope.querySelectorAll('.herbz-vault').forEach(initRoot);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initBodyMode));
})();